/**
 * /Recon — Stripe Checkout success return URL.
 *
 * Stripe appends ?session_id=... so we can show a reference for the
 * client to keep alongside their case number.
 *
 * Visual: single-section recon hero, mirrors the
 * post-commission confirmation page (commission-confirmation.tsx). No
 * @hackereyes/ui imports — all primitives come from /Recon
 * (recon-tokens.css + recon-sections.css + recon-shell.css).
 *
 * The legacy implementation referenced .wizard-container /
 * .wizard-step / .wizard-actions classes that were deleted with the
 * IntakeWizard in commit 18b1c06; the page rendered unstyled until
 * this rebuild.
 */
import { Link, useSearchParams } from "react-router-dom";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  return (
    <div className="recon-page">
      <section className="recon-hero">
        <div className="recon-hero-inner">
          <div className="eyebrow recon-hero-eyebrow">/RECON · PAYMENT RECEIVED</div>
          <h1 className="recon-hero-title">
            Payment received.{" "}
            <span className="text-flame">Your engagement is active.</span>
          </h1>
          <p className="recon-hero-sub">
            Your assessor will begin work shortly. Expect a confirmation email
            and progress updates as the engagement runs. Deliverables land in
            the client portal when each phase wraps.
          </p>
          <div className="recon-hero-cta">
            {/* Link to /portal (the authenticated dashboard) not / —
                see payment-cancelled.tsx for the same fix + rationale. */}
            <Link to="/portal" className="recon-btn recon-btn-primary recon-btn-lg">
              Go to your dashboard
            </Link>
          </div>
          {sessionId && (
            <div className="recon-hero-trust">
              <span className="trust-dot" />
              <span>Reference: {sessionId.slice(0, 24)}…</span>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
